import { Route } from '@angular/router';
import { SectionListComponent } from './section-list/section-list.component';

export const sectionRoutes: Route[] = [
  {
    path: '',
    children: [{ path: '', component: SectionListComponent, title: '' }],
    providers: [
    ],
  },
];
